module.exports = require('./helpers/bundle-url').getBundleURL('bLVlz') + "logo-dark.eefe0b7f.svg";